import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Quiz } from '../components/Quiz';
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ShieldIcon } from 'lucide-react';
export function QuizPage() {
  const [quizCompleted, setQuizCompleted] = useState(false);
  const [riskLevel, setRiskLevel] = useState('');
  const [showExitIntent, setShowExitIntent] = useState(false);
  // Handle exit intent
  useEffect(() => {
    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0 && !quizCompleted && !showExitIntent) {
        setShowExitIntent(true);
      }
    };
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [quizCompleted, showExitIntent]);
  const handleQuizComplete = (score: number) => {
    setQuizCompleted(true);
    // Determine risk level based on score
    if (score <= 3) {
      setRiskLevel('low');
    } else if (score <= 7) {
      setRiskLevel('medium');
    } else {
      setRiskLevel('high');
    }
  };
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-466">
      <Helmet data-id="element-467">
        <title data-id="element-468">HemTryggt | Säkerhetsquiz</title>
        <meta name="description" content="Ta vårt säkerhetsquiz och få en personlig bedömning av ditt hems sårbarhet." data-id="element-469" />
      </Helmet>
      {/* Exit intent popup */}
      {showExitIntent && <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" data-id="element-470">
          <div className="bg-white rounded-lg p-6 max-w-md animate-fade-in" data-id="element-471">
            <h3 className="text-xl font-bold mb-4" data-id="element-472">
              Vill du verkligen avbryta?
            </h3>
            <p className="mb-6" data-id="element-473">
              Du är bara några frågor från att få din personliga
              säkerhetsbedömning. Det tar bara en minut att slutföra.
            </p>
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-474">
              <button onClick={() => setShowExitIntent(false)} className="bg-red-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors" data-id="element-475">
                Fortsätt quizet
              </button>
              <Link to="/" className="px-6 py-3 text-center text-gray-600 hover:text-gray-800" data-id="element-476">
                Ja, avbryt
              </Link>
            </div>
          </div>
        </div>}
      <header className="bg-red-800 text-white px-4 py-6" data-id="element-477">
        <div className="container mx-auto max-w-4xl" data-id="element-478">
          <div className="flex items-center justify-between" data-id="element-479">
            <Link to="/" className="flex items-center text-white hover:text-white/80 transition-colors" data-id="element-480">
              <ArrowLeftIcon className="h-4 w-4 mr-2" data-id="element-481" />
              <span data-id="element-482">Tillbaka</span>
            </Link>
            <div className="flex items-center" data-id="element-483">
              <ShieldIcon className="h-6 w-6 text-white mr-2" data-id="element-484" />
              <h1 className="text-xl md:text-2xl font-bold" data-id="element-485">Säkerhetsquiz</h1>
            </div>
            <div className="w-24" data-id="element-486"></div> {/* Placeholder for balance */}
          </div>
        </div>
      </header>
      <main className="flex-grow bg-gray-50" data-id="element-487">
        <div className="container mx-auto max-w-4xl py-8 px-4" data-id="element-488">
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-489">
            <Quiz onComplete={handleQuizComplete} onQuizProgress={questionNumber => {}} autoStart={true} data-id="element-490" />
          </div>
        </div>
      </main>
      <Footer data-id="element-491" />
    </div>;
}